import { Component, OnInit } from "@angular/core";
import { DialogService } from 'src/app/services/dialog.service';
import { LoginComponent } from '../login/login.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../services/authentication.service";
import { ConfirmedValidator } from "../../helpers/confirmed.validator";
import { InjectDialogComponent } from "../inject-dialog/inject-dialog.component";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {

    registerForm: UntypedFormGroup;
    internalServerError: boolean = false;
    showProgressBar: boolean = false;

    constructor(private dialogService: DialogService,
        private formBuilder: UntypedFormBuilder,
        private authService: AuthenticationService) {
        this.registerForm = this.formBuilder.group({
            'username': ['', [Validators.required]],
            'email': ['', [Validators.required, Validators.email]],
            'password': ['', [Validators.required]],
            'confirmPassword': ['', [Validators.required]]
        }, {
            validator: ConfirmedValidator("password", "confirmPassword")
        });
    }

    ngOnInit(): void {
    }

    register() {
        if (this.registerForm.valid) {
            this.showProgressBar = true;
            this.authService.register(this.registerForm.value).then(
                () => {
                    this.showProgressBar = false;
                    this.dialogService.openDialog(InjectDialogComponent, {
                        title: 'Успешна регистрација',
                        content: 'Испратена Ви е електронска пошта за активација на Вашиот профил на електронската адреса со која се регистриравте. Во случај да не добивте електронска пошта, проверете во Вашата папка за спам.'
                    });
                }
            ).catch(err => {
                this.showProgressBar = false;
                this.internalServerError = true;

                console.error(err);
            });
        }
    }

    onLogin() {
        this.dialogService.openDialog(LoginComponent);
    }
}
